<ng-container *ngIf="reinit; else phoneTmpl">
  <ng-container [ngTemplateOutlet]="phoneTmpl"></ng-container>
</ng-container>
<ng-template #phoneTmpl>
  <input
    type="tel"
    class="ib-phone-iti"
    #telInput
    (keydown.enter)="keydownEnterClick($event)"
    [readonly]="disabled"
    (blur)="blur()"
    (focus)="focus()"
    (keyup)="keyup()"
  />
</ng-template>

<div
  *ngIf="isIntlPhoneDefined && showIntPhone"
  class="text-12px mt-6px text-ino-hint text-left"
>
  International phone {{ formCtrl.value }}
</div>
